/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/488-git': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15.698 7.287L8.712.301a1.03 1.03 0 00-1.457 0L5.632 1.924l1.221 1.221a1.5 1.5 0 012.001 2.001l2 2a1.5 1.5 0 11-.707.707l-2-2A1.569 1.569 0 018 5.914v4.171a1.5 1.5 0 11-1 0V5.914a1.5 1.5 0 01-.854-2.061L4.925 2.632.302 7.255a1.032 1.032 0 000 1.458l6.986 6.986a1.03 1.03 0 001.457 0l6.953-6.953a1.032 1.032 0 000-1.458z"/>'
  }
})
